import { Box } from '@mui/material';
import Image from 'next/image';
import { landingAssets } from '../landing-assets';
import { landingContent, landingCtas } from '../landing-content';
import { LandingCtaButton } from './LandingCtaButton';
import { SectionShell } from './SectionShell';

/** Sticky translucent header: Attend mark plus the two CTAs. */
export function LandingHeader() {
  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        borderBottom: '1px solid rgba(255,255,255,.08)',
        bgcolor: 'rgba(10,10,10,.78)',
        backdropFilter: 'blur(16px)',
        py: { xs: 2, sm: 2.5 },
      }}
    >
      <SectionShell
        component="div"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3 }}
      >
        <Image
          src={landingAssets.attendLogo}
          alt={landingContent.brandLogoAlt}
          width={30}
          height={24}
          priority
        />
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <LandingCtaButton
            cta={landingCtas.learnMore}
            variant="ghost"
            sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
          />
          <LandingCtaButton cta={landingCtas.contactUs} variant="primary" />
        </Box>
      </SectionShell>
    </Box>
  );
}
